import React from 'react'
import { Link } from 'react-router-dom';

import "./Forgetpassword.scss";

function Forgetpassword() {
  return (
    <Link to='/login'>Forgetpassword</Link>
  )
}

export default Forgetpassword